import { render } from "./ArmedResponseView.vue?vue&type=template&id=70e681ea&scoped=true&ts=true"
import script from "./ArmedResponseView.vue?vue&type=script&lang=ts"
export * from "./ArmedResponseView.vue?vue&type=script&lang=ts"

import "./ArmedResponseView.vue?vue&type=style&index=0&id=70e681ea&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70e681ea"]])

export default __exports__